import { TemplateConfig } from '../types';

export const christmasGuidanceConfig: TemplateConfig = {
  id: 'christmas-guidance',
  name: '圣诞节指引',
  description: '复盘过去一年并给出接下来的指引',
  cardCount: 7,
  
  fieldDefaults: {
    title: '圣诞节指引',
    customerQuestion: '复盘过去一年我在各个方面的情况，并给出接下来的指引。',
    cardPlaceholders: [
      '请输入第 3 列第 3 张牌',
      '请输入第 1 列第 1 张牌',
      '请输入第 5 列第 1 张牌',
      '请输入第 3 列第 2 张牌',
      '请输入第 2 列第 1 张牌',
      '请输入第 4 列第 1 张牌',
      '请输入第 3 列第 1 张牌'
    ],
    cardInfos: [
      '1.今年整体回顾。',
      '2.情感/亲密关系复盘。',
      '3.工作/学业/财富复盘。',
      '4.身心情况复盘。',
      '5.这一年做得好的方面。',
      '6.这一年未完成的挑战。',
      '7.接下来的指引。'
    ]
  },
  
  disabledFields: ['title', 'customerQuestion', 'cardCount', 'cardInfos'],
  
  generateOptions: {
    normal: true,
    thinking: true
  },
  
  ui: {
    color: '#389e0d',
    backgroundColor: '#f6ffed',
    icon: '🎄'
  }
};
